import { useEffect, useState } from 'react';
import {
  hasTabBeenTyped,
  markTabTyped,
} from '../typedTabsSession';

const CHAR_MS = 45;

function prefersReducedMotion() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
}

export function useTypewriter(text, tabIndex) {
  const skipTyping =
    prefersReducedMotion() || hasTabBeenTyped(tabIndex);
  const [length, setLength] = useState(skipTyping ? text.length : 0);
  const reducedMotion = prefersReducedMotion();

  useEffect(() => {
    if (skipTyping) {
      setLength(text.length);
      if (!reducedMotion) {
        markTabTyped(tabIndex);
      }
      return undefined;
    }

    if (length >= text.length) {
      markTabTyped(tabIndex);
      return undefined;
    }

    const id = window.setInterval(() => {
      setLength((prev) => {
        const next = prev + 1;
        if (next >= text.length) {
          markTabTyped(tabIndex);
        }
        return next;
      });
    }, CHAR_MS);

    return () => window.clearInterval(id);
  }, [text, tabIndex, skipTyping, reducedMotion, length, text.length]);

  const displayText = text.slice(0, length);
  const cursorBlink = !reducedMotion;

  return { displayText, cursorBlink, reducedMotion };
}
